/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locale_Switcher_LabelInputs */



/**
* | output |
* | --- |
* | "Language" |
*
* @param {Locale_Switcher_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const locale_switcher_label = /** @type {((inputs?: Locale_Switcher_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locale_Switcher_LabelInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprache")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Langue")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("语言")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("語言")
	if (locale === "ko") return /** @type {LocalizedString} */ ("언어")
	return /** @type {LocalizedString} */ ("Language")
});